import config from "config";
import { useState } from "react";
import { getUrlForPath } from "utils/functions";


export default function Image(props) {
    let { src, ...rest} = props;
    const [validSrc, setValidSrc] = useState(src);
    const NO_PHOTO_URL = config.defaultPath + 'no-photo.png';
    if(validSrc === null){
        setValidSrc(NO_PHOTO_URL);
    }
    function onError(e) {
        if(validSrc !== NO_PHOTO_URL){
            setValidSrc(NO_PHOTO_URL)
        }
      }
    return <img src={validSrc} {...rest} onError={(e) => onError(e)} />
}